"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tab-title-page"
  }, [_c("el-divider", {
    staticClass: "middle_divider"
  }), _c("div", {
    staticClass: "child_page"
  }, [_c("settingTab", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeName === "setting",
      expression: "activeName === 'setting'"
    }],
    ref: "settingTab",
    attrs: {
      id: _vm.id
    }
  })], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;